import axios from "axios";
import * as actionTypes from "../actionTypes";
import * as constants from "../../../Data/constants";
import {saveToLocalStorage} from "../../../localStorage";

import { getAuthToken, handleError } from "../../authConfig";
import { addToast } from '../../../components/Toast/actions';

const QUICK_ACTION_SIZE = 5;

export const dashboardStart = () => {
  return {
    type: actionTypes.DASHBOARD_START
  }
}
export const dashboardSuccess = (apps = null, count = null) => {
  return {
    type: actionTypes.DASHBOARD_SUCCESS,
    apps,
    processesCount: count
  };
};

export const dashboardCountSuccess = (count = null) => {
  return {
    type: actionTypes.DASHBOARD_COUNT_SUCCESS,
    processesCount: count
  };
};


export const dashboardProcessCountFilter = (count, id, process_key, filterOptions, selectedOption) => {
  return {
    type: actionTypes.DASHBOARD_FILTER,
    processCount: count.data.data,
    id,
    processKey: process_key,
    filterOptions,
    selectedOption,
  }
}
export const dashboardWorkflowFilter = (app, id, process_key) => {
  return {
    type: actionTypes.DASHBOARD_APP_FILTER,
    app,
    id,
    processKey: process_key
  }
}
export const dashboardFail = (error) => {
  return {
    type: actionTypes.DASHBOARD_ERROR,
    error
  };
};

export const quickActionSuccess = (tasks, total, groupTaskTotal) => {
  return {
    type: actionTypes.QUICK_ACTIONS,
    tasks: tasks,
    total: total,
    groupTaskTotal
  }
}

export const quickActionFail = (error="") => {
  return {
    type: actionTypes.QUICK_ACTIONS_FAIL,
    error
  }
}
export const quickActionStart = () => {
  return {
    type: actionTypes.QUICK_ACTIONS_START,
  }
}


export const dashboardProcessCountLoaderState = (loaderState) => {
  return {
    type: actionTypes.DASHBOARD_PROCESS_COUNT_LOADER_STATE,
    processCountLoader: loaderState
  }
}

export const taskFilterSuccess = (taskFilterData) => {
  return {
    type: actionTypes.TASK_FILTER_SUCCESS,
    taskFilterData
  }
}

export const dashboardDetails = (workflowPermission, allApps, getAllAppsData, getAllProcessCount) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        dispatch(dashboardStart());
        getAuthToken();

        function apps() {
          return axios.get(`/api/apps/?is_global=true`)
        }

        function appsCount() {
          return axios.get("/api/apps/count")
        }

        if(!getAllAppsData) {
          appsCount().then(res => {
            dispatch(dashboardCountSuccess(res.data.data));
            resolve(res);
          })
          .catch(err => {
            dispatch(dashboardProcessCountLoaderState(false))
            dispatch(dashboardFail(err.response));
            reject(err)
          })
        }else if (workflowPermission && allApps) {
          dispatch(dashboardProcessCountLoaderState(true))

          let listOfAPIs = []

          if (getAllProcessCount) listOfAPIs = [apps(), appsCount()]
          else listOfAPIs = [apps()]

          axios.all(listOfAPIs)
            .then(res => {
              dispatch(dashboardSuccess(res[0].data.data, res[1] ? res[1].data.data : {}))
              dispatch(dashboardProcessCountLoaderState(false))
              return resolve(res)
            })
            .catch(err => {
              handleError({
                error: err,
                type: actionTypes.DASHBOARD_ERROR,
                payload: {},
                showToast: true
              });
              dispatch(dashboardFail(err.response))
              dispatch(dashboardProcessCountLoaderState(false))
              reject(err)
            })
        } else {
          apps().then(res => {
              dispatch(dashboardSuccess(res.data.data, getState().dashboard.processCount))
              resolve(res)
            })
            .catch(err => {
              dashboardFail(err.response)
              reject(err)
            })
        }
      })
    }
    };

  export const dashboardQuickActions = () => {
    return dispatch => {
      dispatch(quickActionStart());
      getAuthToken()
      function myTask() {
        return axios
        .get(`/api/proxy-bpm/tasks/?start=0&size=${QUICK_ACTION_SIZE}&includeProcessVariables=true&order=asc&sort=createTime`)
      }
      function myGroupTask() {
        return axios
        .get(`/api/proxy-bpm/group-tasks/?size=1`)
      }
      axios.all([myTask(), myGroupTask()]).then(res => {
          const tasks = res[0].data.data.data;
          const total = res[0].data.data.total;
          const groupTaskTotal = res[1].data.data.total;
          dispatch(quickActionSuccess(tasks, total,groupTaskTotal))
        })
        .catch((err) => {
          dispatch(quickActionFail(err.response))
        });
    }
  };


  export const dashboardCountFilter = (id, process_key, filters, selectedFilter=null) => {
    return dispatch => {
      dispatch(dashboardStart())
      dispatch(dashboardProcessCountLoaderState(true))
      let activeFilter = '';
      let filterOptions = null;
      let selectedOption = '';
      if (filters && process_key in filters) {
        let processFilter = filters[process_key];
        if(Array.isArray(processFilter) && processFilter.length>1) {
          if (selectedFilter) {
            activeFilter = `?filter=${selectedFilter}`;
            selectedOption = selectedFilter;
          }else {
            activeFilter = `?filter=${processFilter[0]}`;
            selectedOption = processFilter[0];
          }
          filterOptions = processFilter;
        }
      }

      axios
        .get(
          `/api/apps/count/${id}${activeFilter}`
        )
        .then(count => {
          dispatch(dashboardProcessCountFilter(count, id, process_key, filterOptions, selectedOption));
          dispatch(dashboardProcessCountLoaderState(false))
        })
        .catch(err => {
          dispatch(dashboardFail(err.response));
          dispatch(dashboardProcessCountLoaderState(false))
          if (err.response && err.response.status) {
            if (err.response.status !== 500) {
              dispatch(addToast('error', 'Error', err.response.data.message))
            } else { 
              dispatch(addToast('error', 'Error', 'Something went wrong!'))
          }
          } 
        })
    }
  }

  export const dashboardAppFilter = (id, process_key, filters, selectedFilter=null) => {
    return dispatch => {
      dispatch(dashboardStart())
      let activeFilter = '';
      if (filters && process_key in filters) {
        let processFilter = filters[process_key];
        if(Array.isArray(processFilter) && processFilter.length>1) {
          if (selectedFilter) {
            activeFilter = `?filter=${selectedFilter}`;
          }else {
            activeFilter = `?filter=${processFilter[0]}`;
          }
        }
      }

      axios.get(`/api/apps/${id}${activeFilter}`)
        .then(app => {
          saveToLocalStorage({
            processKey : process_key,
            id,
            viewPermission : app.data.data.view_permission
          }, constants.DASHBOARD_CURRENT_APP_FILTER_NAME);
          dispatch(dashboardWorkflowFilter(app.data.data, id, process_key));
        })
        .catch(err => {
          dispatch(dashboardFail(err.response));
        })
    }
  }

  export const taskFilter = (groupId) => {
    return dispatch => {
      axios.post(`/api/apps/group_task_count?group_id=${groupId}`)
      .then( res => {
        if(Array.isArray(res.data.filter_base_count) && res.data.filter_base_count.length>0) {
          const taskFilterData = res.data.filter_base_count[0].name
          dispatch(taskFilterSuccess(taskFilterData));
        }
      })
      .catch(() => {})
    }
  } 